import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { sortButtonStyles } from '../../global/constants/theme/styles/tables/sort-button';
import { SearchAppContext, SortBy } from '../models/search-models';
import { updateSort } from '../slices/backend-search-slice';

interface Props {
	type: string,
	labelText: string,
}

export function SortLabel(props: Props) {
	const classes = sortButtonStyles();
	const app = useContext(SearchAppContext);
	const dispatch = useDispatch();
	const [sortBy, setSortBy] = useState(SortBy.DESCENDING);
	const onClick = () => {
		setSortBy(sortBy === SortBy.ASCENDING ? SortBy.DESCENDING : SortBy?.ASCENDING);
		dispatch(updateSort({ type: props?.type, sortBy: sortBy === SortBy.ASCENDING ? SortBy.DESCENDING : SortBy?.ASCENDING }, app));
	};

	return (
		<>

			<button className={`un-button input-label ${classes.sortButton} ${sortBy === SortBy.ASCENDING ? 'active' : ''} `} type='button' onClick={onClick} ><span>{props.labelText} <ArrowDropDownIcon /></span></button>
		</>

	);
}
